interface CurrentUser {
  id: number;
  name: string;
  roles?: string[];
}

export const useCurrentUser = () => {
  const user = useState<CurrentUser | null>('currentUser', () => null);

  const isAuthenticated = computed(() => user.value !== null && user.value.id > 0);

  const setUser = (currentUser: CurrentUser | undefined) => {
    if (currentUser && currentUser.id > 0) {
      user.value = currentUser;
    } else {
      user.value = null;
    }
  };

  return {
    user,
    isAuthenticated,
    setUser,
  };
};
